import { render, staticRenderFns } from "./UsersDeleteDialog.vue?vue&type=template&id=7c2afd90"
import script from "./UsersDeleteDialog.vue?vue&type=script&lang=js"
export * from "./UsersDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports